import { render } from "./tree-select.vue?vue&type=template&id=65800256"
import script from "./tree-select.vue?vue&type=script&lang=js"
export * from "./tree-select.vue?vue&type=script&lang=js"

import "./tree-select.vue?vue&type=style&index=0&id=65800256&lang=less"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__